import { call, put, takeLatest } from "redux-saga/effects";
import AfiliadoFarmaCardActions, {
  Types as AfiliadoFarmaCardTypes,
} from "../../stores/afiliadoFarmaCard/Actions";
import AfiliadoFarmaCardService from "../../services/afiliadoFarmaCard/AfiliadoFarmaCardService";
import ResponseCode from "../../services/ResponseCode";

function* consultarAfiliadoFarmaCard(request) {
  yield put(AfiliadoFarmaCardActions.consultarAfiliadoFarmaCardLoading());

  const {
    queryAfiliado,
    tipoDocumento,
    codigoPss,
  } = request.payload;

  const consultarAfiliadoRequest = {
    Parametro: queryAfiliado,
    Pss: codigoPss || "",
  };

  const afiliadoResponse = yield call(
    AfiliadoFarmaCardService.consultarAfiliadoFarmaCard,
    { requestData: consultarAfiliadoRequest }
  );

  if (
    !afiliadoResponse?.respuesta ||
    afiliadoResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      AfiliadoFarmaCardActions.consultarAfiliadoFarmaCardFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (afiliadoResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      AfiliadoFarmaCardActions.consultarAfiliadoFarmaCardFailure(afiliadoResponse?.respuesta)
    );
    return;
  }

  yield put(
    AfiliadoFarmaCardActions.consultarAfiliadoFarmaCardSuccess({
      ...afiliadoResponse?.data,
      queryAfiliado,
      tipoDocumento
    })
  );
}

function* limpiarDatosAfiliadoFarmaCard() {
  yield put(AfiliadoFarmaCardActions.limpiarDatosAfiliadoFarmaCardLoading());

  yield put(AfiliadoFarmaCardActions.consultarAfiliadoFarmaCardSuccess({}));
}

const exportedArray = [
  takeLatest(AfiliadoFarmaCardTypes.CONSULTAR_AFILIADO_FARMA_CARD, consultarAfiliadoFarmaCard),
  takeLatest(AfiliadoFarmaCardTypes.LIMPIAR_DATOS_AFILIADO_FARMA_CARD, limpiarDatosAfiliadoFarmaCard),
];

export default exportedArray;

